module.exports = __webpack_public_path__ + "static/media/Photo17.38719a2b.jpg";